/**
 * Sync BaB layout to the real site chrome:
 * - --custom-bab-header-offset: visible header (+ announcement) height
 * - --custom-bab-footer-left / --custom-bab-footer-width: pin the fixed
 *   footer to the same horizontal box as the filters / main content
 *   (avoids viewport-vs-scrollbar mismatch as the screen shrinks)
 */
(function () {
  var HEADER_VAR = '--custom-bab-header-offset';
  var FOOTER_LEFT_VAR = '--custom-bab-footer-left';
  var FOOTER_WIDTH_VAR = '--custom-bab-footer-width';
  var SCROLLER_SELECTOR = '.bundleapp-modal__container--complete-screen';
  var FILTERS_SELECTOR = '.awt-filters-container';
  var MAIN_SELECTOR = 'main.bundle-scrollable-section, .bundle-scrollable-section';
  var COMPACT_MQ = '(max-width: 1080px)';
  var scheduled = false;

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 || rect.height > 0;
  }

  function visibleHeight(el) {
    if (!isVisible(el)) return 0;
    var rect = el.getBoundingClientRect();
    return rect.height || el.offsetHeight || 0;
  }

  function getVisibleHeaderEl() {
    var desktopHeader =
      document.querySelector('header.site-header.medium--hide.small--hide') ||
      document.querySelector('header.site-header');
    var mobileHeader = document.querySelector(
      'nav.nav-bar.mobile-nav-bar-wrapper, nav.mobile-nav-bar-wrapper'
    );

    if (isVisible(mobileHeader) && !isVisible(desktopHeader)) return mobileHeader;
    if (isVisible(desktopHeader) && !isVisible(mobileHeader)) return desktopHeader;
    if (isVisible(mobileHeader)) return mobileHeader;
    if (isVisible(desktopHeader)) return desktopHeader;
    return mobileHeader || desktopHeader;
  }

  function measureHeaderOffset() {
    var announcement = document.querySelector(
      '#shopify-section-announcement-bar, .announcement-bar'
    );
    var header = getVisibleHeaderEl();

    var annH = visibleHeight(announcement);
    var headerH = visibleHeight(header);

    if (announcement && header && header.contains(announcement)) {
      annH = 0;
    }

    var total = Math.ceil(annH + headerH);

    if (total < 1) {
      var bottom = 0;
      [announcement, header].forEach(function (el) {
        if (!isVisible(el)) return;
        bottom = Math.max(bottom, el.getBoundingClientRect().bottom);
      });
      total = Math.max(0, Math.ceil(bottom));
    }

    document.documentElement.style.setProperty(HEADER_VAR, total + 'px');
    return total;
  }

  function measureFooterBox() {
    var scroller = document.querySelector(SCROLLER_SELECTOR);
    var filters = document.querySelector(FILTERS_SELECTOR);
    var main = document.querySelector(MAIN_SELECTOR);
    var isCompact = window.matchMedia(COMPACT_MQ).matches;
    var left = 0;
    var width = 0;

    if (isCompact && scroller) {
      // Full-bleed within the scroller's client area (excludes scrollbar)
      var scrollerRect = scroller.getBoundingClientRect();
      left = scrollerRect.left;
      width = scroller.clientWidth;
    } else if (filters && isVisible(filters)) {
      // Match the filters bar exactly (same max-width + centering as content)
      var filterRect = filters.getBoundingClientRect();
      left = filterRect.left;
      width = filterRect.width;
    } else if (main && isVisible(main)) {
      // Fallback: center a ≤1080px bar inside main with 12px gutters
      var mainRect = main.getBoundingClientRect();
      var gutter = 12;
      var available = Math.max(0, mainRect.width - gutter * 2);
      width = Math.min(1080, available);
      left = mainRect.left + gutter + (available - width) / 2;
    } else if (scroller) {
      var rect = scroller.getBoundingClientRect();
      left = rect.left;
      width = scroller.clientWidth;
    } else {
      left = 12;
      width = Math.max(0, window.innerWidth - 24);
    }

    document.documentElement.style.setProperty(FOOTER_LEFT_VAR, Math.round(left) + 'px');
    document.documentElement.style.setProperty(FOOTER_WIDTH_VAR, Math.round(width) + 'px');
  }

  function measureAll() {
    measureHeaderOffset();
    measureFooterBox();
  }

  function scheduleMeasure() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      measureAll();
    });
  }

  function observeEl(el, resizeObserver, mutationObserver) {
    if (!el) return;
    if (resizeObserver) resizeObserver.observe(el);
    else if (mutationObserver) {
      mutationObserver.observe(el, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style'],
      });
    }
  }

  function init() {
    measureAll();

    window.addEventListener('resize', scheduleMeasure, { passive: true });
    window.addEventListener('orientationchange', scheduleMeasure, { passive: true });
    window.addEventListener('scroll', scheduleMeasure, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleMeasure).catch(function () {});
    }

    document
      .querySelectorAll(
        'header.site-header img, nav.mobile-nav-bar-wrapper img, nav.nav-bar.mobile-nav-bar-wrapper img'
      )
      .forEach(function (img) {
        if (!img.complete) img.addEventListener('load', scheduleMeasure, { once: true });
      });

    var resizeObserver = window.ResizeObserver ? new ResizeObserver(scheduleMeasure) : null;
    var mutationObserver = resizeObserver ? null : new MutationObserver(scheduleMeasure);

    observeEl(document.querySelector('#shopify-section-announcement-bar'), resizeObserver, mutationObserver);
    observeEl(document.querySelector('header.site-header'), resizeObserver, mutationObserver);
    observeEl(
      document.querySelector('nav.nav-bar.mobile-nav-bar-wrapper, nav.mobile-nav-bar-wrapper'),
      resizeObserver,
      mutationObserver
    );
    observeEl(
      document.querySelector('.shopify-section-group-header-group'),
      resizeObserver,
      mutationObserver
    );

    var portal = document.querySelector('#bundleapp-subscriptions-portal') || document.body;
    if (resizeObserver) {
      var scroller = document.querySelector(SCROLLER_SELECTOR);
      if (scroller) resizeObserver.observe(scroller);
      var filters = document.querySelector(FILTERS_SELECTOR);
      if (filters) resizeObserver.observe(filters);
      var main = document.querySelector(MAIN_SELECTOR);
      if (main) resizeObserver.observe(main);

      var mountObserver = new MutationObserver(function () {
        var nextScroller = document.querySelector(SCROLLER_SELECTOR);
        var nextFilters = document.querySelector(FILTERS_SELECTOR);
        var nextMain = document.querySelector(MAIN_SELECTOR);
        if (nextScroller) resizeObserver.observe(nextScroller);
        if (nextFilters) resizeObserver.observe(nextFilters);
        if (nextMain) resizeObserver.observe(nextMain);
        scheduleMeasure();
      });
      mountObserver.observe(portal, { childList: true, subtree: true });
    } else {
      observeEl(portal, null, mutationObserver);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
